<template>
  <div class="account-pages mt-5 mb-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-5">
          <div class="card">
            <!-- Logo -->
            <div class="card-header pt-4 pb-4 text-center bg-primary-alternative-for-not-found">
              <a href="index.html">
                <span>
                  <img src="/images/logo-horizontal.svg" alt height="18" />
                </span>
              </a>
            </div>

            <div class="card-body p-4">
              <div class="text-center">
                <div class="d-flex align-items-center justify-content-center">
                  <h1 class="text-error">4</h1>
                  <h1 class="text-error"><i class="mdi mdi-emoticon-sad"></i></h1>
                  <h1 class="text-error">4</h1>
                </div>
                <h4 class="text-uppercase text-danger mt-3"><i></i> {{ $t('views.pages.page_not_found') }}</h4>
                <p class="text-muted mt-3">
                  {{ $t('views.pages.something_gone_wrong') }}
                </p>

                <router-link :to="{ name: 'home' }" class="btn btn-info mt-3 text-decoration-none">
                  <i class="mdi mdi-reply"></i>
                  {{ $t('views.pages.return_homepage') }}
                </router-link>
              </div>
            </div>
            <!-- end card-body-->
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end page -->
</template>

<script>
export default {
  props: {
    resource: {
      type: String,
      required: false
    }
  }
}
</script>

<style scoped>
.bg-primary-alternative-for-not-found {
  background-color: var(--green);
}
</style>
